<script>
  export let size = 40;
</script>

<svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.8">
    <path
      d="M13 11H27C27.5523 11 28 11.4477 28 12V28C28 28.5523 27.5523 29 27 29H13C12.4477 29 12 28.5523 12 28V12C12 11.4477 12.4477 11 13 11ZM15 20V22H17V20H15ZM15 24V26H17V24H15ZM19 20V22H21V20H19ZM19 24V26H21V24H19ZM23 20V26H25V20H23ZM15 14V18H25V14H15Z"
      fill="currentColor"
    />
  </g>
</svg>
